// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Layout_pageWrapper__HGPPx","contentWrapper":"Layout_contentWrapper__af4c0","menuWrapper":"Layout_menuWrapper__KIqvD","pageContent":"Layout_pageContent__Nx3cn"};